import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-general-prompt-save-dialog',
  templateUrl: './general-prompt-save-dialog.component.html',
  styleUrls: ['./general-prompt-save-dialog.component.scss'],
})
export class GeneralPromptSaveDialogComponent {}
